var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-flex',{staticClass:"flex-column"},[_c('study-viewer',{ref:"studyViewer"}),_c('study-report-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }